import Marionette from "marionette";
import template from "apps/Menu/menu/view/template/menu_item.html";


export default Marionette.ItemView.extend("MenuItemView", {
    template,
    tagName: "li",
    className: "menu-li",

    initialize(options) {
        options = options || {};
        this.menu = options.menu;
    },

    onRender() {
        if ( this.model.get("display") == "none" ) {
            this.$el.hide();
        }

        this.$el.toggleClass("active", this.model.get("isActive"));
        if ( this.menu && this.menu.onRenderItem ) {
            this.menu.onRenderItem(this);
        }

    }
});
